module.exports = __webpack_public_path__ + "img/tnbz.670716a5.png";